import { render, staticRenderFns } from "./PaymentNew.vue?vue&type=template&id=2b9a234c&scoped=true&"
import script from "./PaymentNew.vue?vue&type=script&lang=js&"
export * from "./PaymentNew.vue?vue&type=script&lang=js&"
import style0 from "./PaymentNew.vue?vue&type=style&index=0&id=2b9a234c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9a234c",
  null
  
)

export default component.exports